import { routes } from "../../routes/constants/routes"
import { history } from "../../store"

export const navigateToCertificate = (courseId: string) =>
  history.push(routes.APP.COURSE_CERTIFICATE.replace(":id", courseId))
